import React from "react";
//#region types
import { VoucherInfoProps } from "models/propTypes/accountingPropTypes";
//#endregion
//#region components
import { SimpleTooltip } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const VoucherInfo: React.FC<VoucherInfoProps> = (props) => {
  const { series, voucherNumber, seriesName } = props;

  return (
    <Grid container direction="row" spacing={2} alignItems="center" wrap="nowrap">
      <Grid item>
        <SimpleTooltip text={seriesName}>
          <Grid item container className={cssExports.voucherSeries}>
            {series}
          </Grid>
        </SimpleTooltip>
      </Grid>
      <Grid item container xs direction="column">
        {voucherNumber}
      </Grid>
    </Grid>
  );
};

export default VoucherInfo;
